
/*
 * Copyright (c) 2026 Ayman Elamrani & NAJA AI. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of Ayman Elamrani.
 * ("Confidential Information"). You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms of the
 * license agreement you entered into with Ayman Elamrani.
 */

import React from 'react';
import { Capacitor } from '@capacitor/core';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MarketingHome from './frontend/pages/MarketingHome';

import PitchDeckPage from './frontend/pages/PitchDeckPage';
import CeoPage from './frontend/pages/CeoPage';

import ConsoleApp from './app/components/ConsoleApp';
import DisclaimerPage from './frontend/components/DisclaimerPage';

const App: React.FC = () => {
    return (
        <Router>
            <Routes>
                {/* LEGAL DISCLAIMER */}
                <Route path="/legal" element={<DisclaimerPage />} />
                <Route path="/disclaimer" element={<DisclaimerPage />} />

                {/* REAL APP CONSOLE */}
                <Route path="/app" element={<ConsoleApp />} />
                <Route path="/console" element={<ConsoleApp />} />

                {/* SINGLE COMPREHENSIVE MARKETING PAGE */}
                <Route path="/" element={Capacitor.isNativePlatform() ? <ConsoleApp /> : <MarketingHome />} />

                {/* INVESTOR PITCH DECK */}
                <Route path="/pitch-deck" element={<PitchDeckPage />} />
                <Route path="/ceo" element={<CeoPage />} />
                <Route path="/investors" element={<PitchDeckPage />} />

                {/* ALL OTHER ROUTES REDIRECT TO HOME */}
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
};

export default App;
